module.exports = __webpack_public_path__ + "img/rightbicep.50b959f1.svg";